import { render } from "./LegalNoticePopup.vue?vue&type=template&id=2e2620eb"
import script from "./LegalNoticePopup.vue?vue&type=script&lang=js"
export * from "./LegalNoticePopup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Kotasyon\\Kotasyon\\dijital-saglik-sigortasi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__